export default function CheckboxWithLabel ({
  id,
  label,
  checked = false,
  onChange,
  disabled = false,
  className = ''
}) {
  return (
    <label
      htmlFor={id}
      className={`flex items-center space-x-2 cursor-pointer select-none ${
        disabled ? 'opacity-60 cursor-not-allowed' : ''
      } ${className}`}
    >
      <input
        id={id}
        type='checkbox'
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange?.(e.target.checked)}
        className='h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500'
      />
      <span className='text-gray-800'>{label}</span>
    </label>
  )
}
